import $ from 'jquery';
import AOS from 'aos';

/* Animate on scroll */
$(document).ready(function () {
});

$(window).on('load', function() {
  AOS.init({
     once: true,
  });
});
